import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
    faCircle,
    faRandom,
    faTimes,
    faTrash,
    faSpinner,
    faCalendarAlt,
    faShoppingBasket,
    faCircleNotch,
    faPrint,
    faPlug,
    faCheck,
    faWindowRestore,
    faStar,
    faCaretDown,
    faCaretUp,
    faTrophy,
    faClone,
    faVolumeUp,
    faVolumeOff,
    faChevronLeft,
    faChevronRight,
    faQuestionCircle,
    faPlus,
    faInfoCircle
} from '@fortawesome/free-solid-svg-icons'

library.add(
    faCircle,
    faRandom,
    faTimes,
    faTrash,
    faSpinner,
    faCalendarAlt,
    faShoppingBasket,
    faCircleNotch,
    faPrint,
    faPlug,
    faCheck,
    faWindowRestore,
    faStar,
    faCaretDown,
    faCaretUp,
    faTrophy,
    faClone,
    faVolumeUp,
    faVolumeOff,
    faChevronLeft,
    faChevronRight,
    faQuestionCircle,
    faPlus,
    faInfoCircle
);

Vue.component('fa-icon', FontAwesomeIcon)